import React from 'react';

function SvgCarretArrowDownJAG(props) {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.5 6.04907L10.5 0.166718H0.5L5.5 6.04907Z" fill="black" />
    </svg>
  );
}

export default SvgCarretArrowDownJAG;
